import { NetworkActionPrefix, ActionType } from '../utils/constants';
import {
    UserDataVisibilityFunctionApi, UserRoleProductApi, UserRoleApi, UserListDataReportApi,
    UserDataVisibilitySettingsApi, UserDataVisibilityProductApi, UserDataVisibilityLegalEntityApi
} from 'for-straction-service-api';
import { networkAPIAction } from '../utils/actionCreatorsFactory';

const userDataVisibilityFunctionApi = new UserDataVisibilityFunctionApi();
const userDataVisibilityLegalEntityApi = new UserDataVisibilityLegalEntityApi();
const userDataVisibilityProductApi = new UserDataVisibilityProductApi();
const userDataVisibilitySettingsApi = new UserDataVisibilitySettingsApi();
const userRoleProductApi = new UserRoleProductApi();

const userList = {
    addUserDataVisibilityFunction(id, companyFunction) {
        return dispatch => {
            dispatch({
                type: ActionType.ADD_USER_DATA_VISIBILITY_FUNCTION,
                companyFunctionID: id,
                companyFunction
            });

            dispatch(userList.syncNewVisibilityFunction(id, companyFunction));
        }
    },
    syncNewVisibilityFunction(id, companyFunction) {
        return networkAPIAction(userDataVisibilityFunctionApi, 'userDataVisibilityFunctionAddPut', NetworkActionPrefix.ADD_USER_DATA_VISIBILITY_FUNCTION_PREFIX,
            { companyFunctionID: id, companyFunction }, companyFunction);
    },
    deleteUserDataVisibilityFunctions(id) {
        return dispatch => {
            dispatch({
                type: ActionType.DELETE_USER_DATA_VISIBILITY_FUNCTION,
                companyFunctionID: id
            });

            dispatch(userList.syncDeletedFunctions(id));
        }
    },
    syncDeletedFunctions(id) {
        return networkAPIAction(userDataVisibilityFunctionApi, 'userDataVisibilityFunctionDeleteGet', NetworkActionPrefix.DELETE_USER_DATA_VISIBILITY_FUNCTION_PREFIX, { companyFunctionID: id }, id);
    },
    addUserDataVisibilityLegalEntity(id, legalEntity) {
        return dispatch => {
            dispatch({
                type: ActionType.ADD_USER_DATA_VISIBILITY_LEGAL_ENTITY,
                legalEntityID: id,
                legalEntity
            });

            dispatch(userList.syncNewVisibilityEntity(id, legalEntity));
        }
    },
    syncNewVisibilityEntity(id, legalEntity) {
        return networkAPIAction(userDataVisibilityLegalEntityApi, 'userDataVisibilityLegalEntityAddPut', NetworkActionPrefix.ADD_USER_DATA_VISIBILITY_LEGAL_ENTITY_PREFIX,
            { legalEntityID: id, legalEntity }, legalEntity);
    },
    deleteUserDataVisibilityLegalEntity(id) {
        return dispatch => {
            dispatch({
                type: ActionType.DELETE_USER_DATA_VISIBILITY_LEGAL_ENTITY,
                legalEntityID: id
            });

            dispatch(userList.syncDeletedEntities(id));
        }
    },
    syncDeletedEntities(id) {
        return networkAPIAction(userDataVisibilityLegalEntityApi, 'userDataVisibilityLegalEntityDeleteGet', NetworkActionPrefix.DELETE_USER_DATA_VISIBILITY_LEGAL_ENTITY_PREFIX, { legalEntityID: id }, id);
    },
    addUserDataVisibilityProduct(id, product) {
        return dispatch => {
            dispatch({
                type: ActionType.ADD_USER_DATA_VISIBILITY_PRODUCT,
                productID: id,
                product
            });

            dispatch(userList.syncNewVisibilityProduct(id, product));
        }
    },
    syncNewVisibilityProduct(id, product) {
        return networkAPIAction(userDataVisibilityProductApi, 'userDataVisibilityProductAddPut', NetworkActionPrefix.ADD_USER_DATA_VISIBILITY_PRODUCT_PREFIX, { productID: id, product }, product);
    },
    deleteUserDataVisibilityProducts(id) {
        return dispatch => {
            dispatch({
                type: ActionType.DELETE_USER_DATA_VISIBILITY_PRODUCT,
                productID: id
            });

            dispatch(userList.syncDeletedProducts(id));
        }
    },
    syncDeletedProducts(id) {
        return networkAPIAction(userDataVisibilityProductApi, 'userDataVisibilityProductDeleteGet', NetworkActionPrefix.DELETE_USER_DATA_VISIBILITY_PRODUCT_PREFIX, { productID: id }, id);
    },
    addUserDataVisibilitySettings(id, settings) {
        return dispatch => {
            dispatch({
                type: ActionType.ADD_USER_DATA_VISIBILITY_SETTINGS,
                settingsID: id,
                settings
            });

            dispatch(userList.syncNewVisibilitySettings(id, settings));
        }
    },
    syncNewVisibilitySettings(id, settings) {
        return networkAPIAction(userDataVisibilitySettingsApi, 'userDataVisibilitySettingsAddPut', NetworkActionPrefix.ADD_USER_DATA_VISIBILITY_SETTINGS_PREFIX,
            { settingsID: id, settings }, settings);
    },
    editUserDataVisibilitySettings(id, settings) {
        return dispatch => {
            dispatch({
                type: ActionType.EDIT_USER_DATA_VISIBILITY_SETTINGS,
                settingsID: id,
                settings
            });

            dispatch(userList.syncVisibilitySettings(id, settings));
        }
    },
    syncVisibilitySettings(id, settings) {
        return networkAPIAction(userDataVisibilitySettingsApi, 'userDataVisibilitySettingsEditPut',
            NetworkActionPrefix.EDIT_USER_DATA_VISIBILITY_SETTINGS_PREFIX, { settingsID: id, settings }, settings, id);
    },
    addUserRoleProduct(id, roleProduct) {
        return dispatch => {
            dispatch({
                type: ActionType.ADD_USER_ROLE_PRODUCT,
                roleProductID: id,
                roleProduct
            });

            dispatch(userList.syncNewRoleProduct(id, roleProduct));
        }
    },
    syncNewRoleProduct(id, roleProduct) {
        return networkAPIAction(userRoleProductApi, 'userRoleProductAddPut', NetworkActionPrefix.ADD_USER_ROLE_PRODUCT_PREFIX, { roleProductID: id, roleProduct }, roleProduct);
    },
    deleteUserRoleProduct(id) {
        return dispatch => {
            dispatch({
                type: ActionType.DELETE_USER_ROLE_PRODUCT,
                roleProductID: id
            });

            dispatch(userList.syncDeletedRoleProduct(id));
        }
    },
    syncDeletedRoleProduct(id) {
        return networkAPIAction(userRoleProductApi, 'userRoleProductDeleteGet', NetworkActionPrefix.DELETE_USER_ROLE_PRODUCT_PREFIX, { roleProductID: id }, id);
    },
    loadUserDataVisibilityFunctions:
    networkAPIAction.bind(this, userDataVisibilityFunctionApi, 'userDataVisibilityFunctionLoadAllGet', NetworkActionPrefix.LOAD_USER_DATA_VISIBILITY_FUNCTIONS_PREFIX, {}),
    loadUserDataVisibilityLegalEntities:
    networkAPIAction.bind(this, userDataVisibilityLegalEntityApi, 'userDataVisibilityLegalEntityLoadAllGet', NetworkActionPrefix.LOAD_USER_DATA_VISIBILITY_LEGAL_ENTITIES_PREFIX, {}),
    loadUserDataVisibilityProducts:
    networkAPIAction.bind(this, userDataVisibilityProductApi, 'userDataVisibilityProductLoadAllGet', NetworkActionPrefix.LOAD_USER_DATA_VISIBILITY_PRODUCTS_PREFIX, {}),
    loadUserDataVisibilitySettings:
    networkAPIAction.bind(this, userDataVisibilitySettingsApi, 'userDataVisibilitySettingsLoadAllGet', NetworkActionPrefix.LOAD_USER_DATA_VISIBILITY_SETTINGS_PREFIX, {}),
    loadUserDataReport: networkAPIAction.bind(this, new UserListDataReportApi(), 'userListDataReportLoadReportGet', NetworkActionPrefix.LOAD_USER_LIST_REPORT_PREFIX, {}),
    loadUserRoles: networkAPIAction.bind(this, new UserRoleApi(), 'userRoleLoadAllGet', NetworkActionPrefix.LOAD_USER_ROLES_PREFIX, {}),
    loadUserRoleProducts: networkAPIAction.bind(this, userRoleProductApi, 'userRoleProductLoadAllGet', NetworkActionPrefix.LOAD_USER_ROLE_PRODUCTS_PREFIX, {})
};

export default userList;